import axios from "axios";

const API_BASE_URL = "https://api.mctwister.in/api/v1/";

// const API_BASE_URL = "http://192.168.2.249:8080/api/v1/";


let logoutHandler = null;

export const setLogoutFunction = (fn) => {
  logoutHandler = fn;
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("API Error:", error.response || error.message);
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.warn("Unauthorized! Logging out...");

      if (logoutHandler) logoutHandler();
    }

    return Promise.reject(error);
  }
);

export default api;
